import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

const useLockingSystemStore = create(
  devtools((set, get) => ({
    // Locking System Tool
    lockingSystem: {
      enabled: true,
      selectedSystem: null,
      showModal: false,
      customizationEnabled: false,
      // Custom parameters
      diameter: 63.0,
      depth: 25.0
    },

    // Actions
    setLockingSystem: (data) => set({ lockingSystem: { ...get().lockingSystem, ...data } }),

    // Reset all data
    reset: () => set({
      lockingSystem: { 
        enabled: true, 
        selectedSystem: null, 
        showModal: false, 
        customizationEnabled: false,
        diameter: 63.0,
        depth: 25.0
      }
    })
  }))
);

export default useLockingSystemStore;